"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeterReadsSummary = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("../../../../shared/core");
var kapi_meter_reads_1 = require("../../../kapi-meter-reads");
var MeterReadingsContext_1 = require("../../MeterReadingsContext");
var MeterReadingsData_1 = require("../../components/MeterReadingsData/MeterReadingsData");
var MeterReadsSummaryUI_1 = require("./ui/MeterReadsSummaryUI");
var components_1 = require("./ui/components");
function MeterReadsSummaryInnerWithDataContext() {
    var _a = (0, react_1.useContext)(MeterReadingsContext_1.MeterReadingsContext), readings = _a.readings, supplies = _a.supplies, latestBilling = _a.latestBilling;
    var latestBillingEndDate = (latestBilling === null || latestBilling === void 0 ? void 0 : latestBilling.billingSummary) &&
        'latestPeriod' in latestBilling.billingSummary
        ? latestBilling === null || latestBilling === void 0 ? void 0 : latestBilling.billingSummary.latestPeriod.data.end
        : null;
    return (react_1.default.createElement(MeterReadsSummaryUI_1.MeterReadsSummaryUI, { elecMeterReads: readings.electricity, gasMeterReads: readings.gas, supplies: supplies, latestBillingEndDate: latestBillingEndDate }));
}
exports.MeterReadsSummary = (0, core_1.withCustomerAndAccountIds)(function () {
    var meterReads = core_1.configService.getConfig().meterReads;
    if (meterReads === null || meterReads === void 0 ? void 0 : meterReads.kapiOnly) {
        return react_1.default.createElement(kapi_meter_reads_1.KapiMeterReadsSummary, null);
    }
    return (react_1.default.createElement(MeterReadingsData_1.MeterReadingsData, { Error: components_1.Error, NoData: components_1.Loading },
        react_1.default.createElement(MeterReadsSummaryInnerWithDataContext, null)));
}, components_1.Loading);
